var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { inject, observer } from 'mobx-react';
import { PositionType } from 'uitk-react-menu';
import { UitkButton } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { getGCSectionData } from '../gc-section-data';
import { HeaderMenu } from '../header-menu';
var ButtonTracked = ClickTracker(UitkButton);
var HeaderNavLobLinks = /** @class */ (function (_super) {
    __extends(HeaderNavLobLinks, _super);
    function HeaderNavLobLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNavLobLinks.prototype.render = function () {
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, numberOfLinks = _a.numberOfLinks, page = _a.page, analytics = _a.analytics;
        var l10n = (globalComponentsContext && globalComponentsContext.header && globalComponentsContext.header.l10n) || {};
        var primaryMenuLinks = getGCSectionData(globalComponentsContext, 'header', 'navLinks');
        var links = primaryMenuLinks && primaryMenuLinks.sectionData
            ? primaryMenuLinks.sectionData.filter(function (s) { return s.type === 'link' || s.type === 'menu-v2'; }).slice(0, numberOfLinks)
            : [];
        if (!links || links.length === 0) {
            return null;
        }
        return (links
            && links.map(function (link) {
                if (!link || !link.text) {
                    return null;
                }
                if (link.type === 'menu-v2') {
                    return React.createElement(HeaderMenu, { key: link.id, menu: link, width: 375, position: PositionType.LEFT, analytics: analytics });
                }
                var active = link.id === page.navigationId;
                var classes = [
                    'global-navigation-nav-button'
                ];
                if (active) {
                    classes.push('global-navigation-nav-button-active');
                }
                var suffix = link.text ? link.text.replace(/ /g, '') : '';
                var hyperlink = link.url;
                return (React.createElement(UitkSpacing, { padding: { block: 'two' }, key: "div-" + link.id },
                    React.createElement(ButtonTracked, { events: "click", href: hyperlink, className: classes.join(' '), rfrr: link.trackingEvent, target: link.newWindow ? '_blank' : '_self', linkName: link.id, trackImmediate: true }, link.text
                        && (React.createElement(UitkText, { size: 300 },
                            link.text,
                            active && React.createElement("span", { className: "is-visually-hidden" }, l10n.navigationSelectedA11yLabel))))));
            }));
    };
    HeaderNavLobLinks = __decorate([
        inject('page'),
        observer
    ], HeaderNavLobLinks);
    return HeaderNavLobLinks;
}(React.Component));
export { HeaderNavLobLinks };
//# sourceMappingURL=header-nav-lob-links.js.map